import React from "react";

const FingerTouchIcon = ({ width, height, color }) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31.5" cy="31.5" r="31.5" fill="#00008B" fillOpacity="0.1" />
      <path
        d="M41.01 36.1049L41.0254 36.1128L41.0414 36.1195C41.6908 36.3948 42.1726 37.0821 42.1726 37.8828C42.1726 37.9375 42.1631 38.013 42.1459 38.1357L42.1459 38.136L40.9628 46.6235C40.9627 46.6241 40.9626 46.6248 40.9625 46.6254C40.82 47.5858 40.0904 48.259 39.1849 48.259H28.4691C27.9638 48.259 27.4907 48.0446 27.1534 47.7001L19.6977 40.088L20.604 39.1511C20.6043 39.1507 20.6047 39.1504 20.605 39.15C20.8346 38.9161 21.1504 38.7695 21.4935 38.7695C21.5259 38.7695 21.559 38.773 21.6076 38.781C21.6166 38.7824 21.6295 38.7847 21.6448 38.7874C21.6832 38.7942 21.737 38.8037 21.7862 38.8107L27.1806 39.9668L27.7854 40.0965V39.4779V22.1727C27.7854 21.1016 28.6287 20.2557 29.6527 20.2557C30.6767 20.2557 31.52 21.1016 31.52 22.1727V31.8404V32.3404H32.02H33.2194C33.4401 32.3404 33.6533 32.3864 33.862 32.472L41.01 36.1049ZM25.2072 22.1727V27.1608C23.8795 25.9258 23.0509 24.1525 23.0509 22.1727C23.0509 18.4269 26.0089 15.4219 29.6527 15.4219C33.2965 15.4219 36.2545 18.4269 36.2545 22.1727C36.2545 24.1525 35.4259 25.9258 34.0981 27.1608V22.1727C34.0981 19.6828 32.1165 17.6445 29.6527 17.6445C27.1889 17.6445 25.2072 19.6828 25.2072 22.1727Z"
        stroke="#FF4400"
      />
    </svg>
  );
};

export default FingerTouchIcon;
